<template>
  <div class="input">
    <div class="input-label">管理者</div>
    <div class="input-group">
      <input type="checkbox" v-model="admin">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    admin: {
      get: function () {
        return this.$store.state.user.admin
      },
      set: function (value) {
        this.$store.commit(
          'user/setAdmin',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
